import { Phone, Mail, MapPin, Clock } from "lucide-react";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      {/* Hero Section */}
      <section className="py-24 bg-[#0F172A]">
        <div className="container-custom">
          <div className="max-w-3xl animate-fadeInUp">
            <span className="text-[#F97316] font-semibold uppercase tracking-wider text-sm">Get In Touch</span>
            <h1 className="heading-h1 text-white mt-2 mb-6">CONTACT US</h1>
            <p className="text-slate-300 text-lg">
              Ready to fix your roof? Contact us today for a free inspection and estimate. 
              Our team is standing by to help with all your roofing needs.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-padding bg-gray" data-testid="contact-form-section">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Info */}
            <div className="animate-fadeInUp">
              <h2 className="heading-h2 text-slate-900 mb-6">GET IN TOUCH</h2>
              <p className="text-body mb-8">
                Have questions about our services? Need an emergency repair? 
                We're here to help 24/7. Reach out through any of the methods below.
              </p>
              
              <div className="space-y-6">
                {/* Phone */}
                <div className="flex items-start gap-4 p-6 bg-white rounded-lg shadow-sm">
                  <div className="w-12 h-12 bg-orange-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-[#F97316]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 mb-1">Phone</h3>
                    <a href="tel:+18884451244" className="text-[#F97316] font-semibold text-lg hover:underline">
                      +1-888-445-1244
                    </a>
                    <p className="text-slate-500 text-sm mt-1">24/7 Emergency Line Available</p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4 p-6 bg-white rounded-lg shadow-sm">
                  <div className="w-12 h-12 bg-orange-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-[#F97316]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 mb-1">Email</h3>
                    <a href="mailto:support@cartgenix.store" className="text-[#F97316] font-semibold hover:underline">
                      support@cartgenix.store
                    </a>
                    <p className="text-slate-500 text-sm mt-1">We respond within 24 hours</p>
                  </div>
                </div>

                {/* Address */}
                <div className="flex items-start gap-4 p-6 bg-white rounded-lg shadow-sm">
                  <div className="w-12 h-12 bg-orange-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-[#F97316]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 mb-1">Office Location</h3>
                    <p className="text-slate-700">
                      998 Sunset Boulevard<br />
                      Los Angeles, CA 80021
                    </p>
                  </div>
                </div>

                {/* Hours */}
                <div className="flex items-start gap-4 p-6 bg-white rounded-lg shadow-sm">
                  <div className="w-12 h-12 bg-orange-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-[#F97316]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 mb-1">Business Hours</h3>
                    <div className="text-slate-700 space-y-1">
                      <p>Mon - Fri: 7:00 AM - 6:00 PM</p>
                      <p>Sat: 8:00 AM - 4:00 PM</p>
                      <p>Sun: Closed</p>
                      <p className="text-[#F97316] font-semibold mt-2">Emergency Service: 24/7</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white p-8 rounded-lg shadow-lg animate-fadeInUp delay-200">
              <h3 className="heading-h3 text-slate-900 mb-2">Request Free Estimate</h3>
              <p className="text-body mb-6">
                Fill out the form below and we'll get back to you within 24 hours.
              </p>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-8 bg-slate-200">
        <div className="container-custom">
          <div className="bg-slate-300 h-64 md:h-80 rounded-lg flex items-center justify-center">
            <div className="text-center">
              <MapPin className="w-12 h-12 text-slate-500 mx-auto mb-4" />
              <p className="text-slate-600 font-semibold">998 Sunset Boulevard</p>
              <p className="text-slate-500">Los Angeles, CA 80021</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
